import myZoneServiceProvider from '@/api/serviceProviders/my-zone'
import { JsonClass } from '@/types/api/product/productTypes'
import { LoadAvailableJsonClassOptionsResponse,
    LoadAvailableJsonClassOptionsResponseData } from '@/types/api/product/productResponses'

/**
 * Load all available product classes
 * @returns LoadAvailableJsonClassOptionsResponse
 */
export const loadAvailableJsonClasses = async (context?: string): Promise<LoadAvailableJsonClassOptionsResponseData> => {
    const response = await myZoneServiceProvider.get('condition-rules/options', context ? {
        params: {
            context, 
        },
    } : undefined) as LoadAvailableJsonClassOptionsResponse

    return response.data.data.map((jsonClass: JsonClass) => {
        return {
            key: jsonClass.id,
            label: jsonClass.label,
            value: jsonClass.value,
            options: jsonClass.options,
            legend: jsonClass.legend,
            active: jsonClass.active,
            icon: jsonClass.icon,
        }
    })
}